import { memo, useContext } from 'react'
import { ContractorDeactivationReason, ContractorStatus } from 'src/constants/contractor/enums'
import { OnboardingStatus } from 'src/constants/onboarding/enums'
import { ContractorStatusChip } from '../contractor-list/shared/ContractorStatusChip'
import { OnboardingStatusChip } from '../onboarding/shared/OnboardingStatusChip'
import { ContractorDetailsModalContext } from './ContractorDetailsModal.context'

interface Props {
  contractorStatus?: ContractorStatus | null
  deactivationReason?: ContractorDeactivationReason | null
  deactivatedByEmail?: string | null
  deactivatedAt?: string | null
  onboardingStatus?: OnboardingStatus | null
  failedAt?: string | null
  failedSteps?: string[]
  expiredSteps?: string[]
  onboardedAt?: string | null
}

const ContractorOnboardingStatusChipComponent = ({
  contractorStatus,
  deactivationReason,
  deactivatedByEmail,
  deactivatedAt,
  onboardingStatus,
  failedAt,
  failedSteps,
  expiredSteps,
  onboardedAt,
}: Props) => {
  const { statusIsUpdating } = useContext(ContractorDetailsModalContext)

  if (onboardingStatus && !onboardedAt) {
    return (
      <OnboardingStatusChip
        onboardingStatus={onboardingStatus}
        failedAt={failedAt}
        failedSteps={failedSteps}
        statusIsUpdating={statusIsUpdating}
      />
    )
  }

  if (contractorStatus) {
    return (
      <ContractorStatusChip
        status={contractorStatus}
        deactivationReason={deactivationReason}
        deactivatedByEmail={deactivatedByEmail}
        deactivatedAt={deactivatedAt}
        expiredSteps={expiredSteps}
        failedSteps={failedSteps}
        statusIsUpdating={statusIsUpdating}
      />
    )
  }

  return null
}

export const ContractorOnboardingStatusChip = memo(ContractorOnboardingStatusChipComponent)
